import { Autocomplete, Box, Grid, TextField } from "@mui/material";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import SelectFormItem, { SelectMultipleFormItem } from "components/Input/Select";
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { CheckboxFormItem, InputNumberForm, RadioForm, TextBoxForm } from "components/Input";
import Divider from "components/Divider";
import "./Register.css";
import { FiArrowRight, FiArrowLeft } from "react-icons/fi";
import React from "react";
import { RegisterContext } from "..";
import { undefinedOrNull } from "utilities/Function";

const StepForm6 = () => {
  const { handleNext, handleBack, objMasterData, formStep6, nReplyID1, setnReplyID1, nReplyID9, setnReplyID9,nReplyID7, setnReplyID7,nReplyID8, setnReplyID8,
    nReplyID11, setnReplyID11, nSexID, nReplyID10, setnReplyID10, nReplyID12, setnReplyID12, nReplyID3, setnReplyID3 } = React.useContext(RegisterContext);

  return (
    <FormProvider {...formStep6}>
      <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
        <Grid item md={12} xs={12}>
          <Divider>ข้อมูลส่วนตัวอื่นๆ เพิ่มเติม</Divider>
        </Grid>
        {(objMasterData.lstMQuestion || []).filter(f => nSexID === 15 ? f.nQuestionID != 12 : true).map(item => {
          return <Grid item md={6} xs={12} marginTop={1} paddingRight={1}>
            <div className="MainGroup">
              <div className="divTitel">{item.nNo + " " + item.sQuestionName}</div>
              <div className="divQBoby">
                <div className="divQitem">
                  {(() => {
                    switch (item.nQuestionID) {
                      case 1: {
                        return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                          <Grid item md={12} xs={12}>
                            <RadioForm name={"nReplyID1"} options={objMasterData.lstReply1 || []} isShowRow isNoLabel onChange={(e) => {
                              setnReplyID1(undefinedOrNull(e, "number"))
                            }} />
                          </Grid>
                          {nReplyID1 === 63 && <Grid item md={12} xs={12}>
                            <SelectMultipleFormItem options={objMasterData?.lstOptionReply1 || []} name={"lstOptionReplyID1"} label={"ประเภทรถยนต์"} required />
                          </Grid>}
                        </Grid>;
                      };
                      case 2: {
                        return <RadioForm name={"nReplyID2"} options={objMasterData.lstReply2 || []} isShowRow isNoLabel />
                      };
                      case 3: {
                        return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                          <Grid item md={12} xs={12}>
                            <RadioForm name={"nReplyID3"} options={objMasterData.lstReply3 || []} isShowRow isNoLabel onChange={(e) => {
                              setnReplyID3(undefinedOrNull(e, "number"))
                            }} />
                          </Grid>
                          {nReplyID3 === 67 && <Grid item md={12} xs={12}>
                            <SelectMultipleFormItem options={objMasterData?.lstOptionReply3 || []} name={"lstOptionReplyID3"} label={"ประเภทใบขับขี่"} required />
                          </Grid>}
                        </Grid>
                      }
                      case 4: { return <RadioForm name={"nReplyID4"} options={objMasterData.lstReply4 || []} isShowRow isNoLabel /> }
                      case 5: { return <RadioForm name={"nReplyID5"} options={objMasterData.lstReply5 || []} isShowRow isNoLabel /> }
                      case 6: { return <RadioForm name={"nReplyID6"} options={objMasterData.lstReply6 || []} isShowRow isNoLabel /> }
                      // case 7: { return <RadioForm name={"nReplyID7"} options={objMasterData.lstReply7 || []} isShowRow isNoLabel /> }
                      case 7: {
                        return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                          <Grid item md={12} xs={12}>
                            <RadioForm name={"nReplyID7"} options={objMasterData.lstReply7 || []} isShowRow isNoLabel onChange={(e) => {
                              setnReplyID7(undefinedOrNull(e, "number"))
                            }} />
                          </Grid>
                          {nReplyID7 === 75 && <Grid item md={12} xs={12}>
                            <TextBoxForm name={"sOther7"} label={"โทษคดี"} maxLength={450}/>
                          </Grid>}
                        </Grid>
                      }
                      // case 8: { return <RadioForm name={"nReplyID8"} options={objMasterData.lstReply8 || []} isShowRow isNoLabel /> }
                      case 8: {
                        return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                          <Grid item md={12} xs={12}>
                            <RadioForm name={"nReplyID8"} options={objMasterData.lstReply8 || []} isShowRow isNoLabel onChange={(e) => {
                              setnReplyID8(undefinedOrNull(e, "number"))
                            }} />
                          </Grid>
                          {nReplyID8 === 77 && <Grid item md={12} xs={12}>
                            <TextBoxForm name={"sOther8"} label={"สาเหตุ"} maxLength={450}/>
                          </Grid>}
                        </Grid>
                      }
                      case 9: {
                        return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                          <Grid item md={12} xs={12}>
                            <RadioForm name={"nReplyID9"} options={objMasterData.lstReply9 || []} isShowRow isNoLabel onChange={(e) => {
                              setnReplyID9(undefinedOrNull(e, "number"))
                            }} />
                          </Grid>
                          {nReplyID9 === 94 && <Grid item md={12} xs={12}>
                            <TextBoxForm name={"sOther9"} label={"โรคเรื้อรัง/โรคติดต่อร้ายแรง"} maxLength={450} required/>
                          </Grid>}
                        </Grid>
                      }
                      case 10: {
                        return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                          <Grid item md={12} xs={12}>
                            <RadioForm name={"nReplyID10"} options={objMasterData.lstReply10 || []} isShowRow isNoLabel
                              onChange={(e) => {
                                setnReplyID10(undefinedOrNull(e, "number"))
                              }} />
                          </Grid>
                          {nReplyID10 == 80 && <Grid item md={12} xs={12}>
                            <TextBoxForm name={"sOther10"} label={"เพิ่มเติม"} maxLength={450} />
                          </Grid>}
                        </Grid>
                      }
                      case 11: {
                        return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                          <Grid item md={6} xs={12}>
                            <RadioForm name={"nReplyID11"} options={objMasterData.lstReply11 || []} isShowRow isNoLabel onChange={(e) => {
                              setnReplyID11(undefinedOrNull(e, "number"))
                            }} />
                          </Grid>
                          {nReplyID11 == 81 && <Grid item md={12} xs={12}>
                            <TextBoxForm name={"sOther11"} label={"ชื่อหน่วยงานหรือบริษัท"} required maxLength={450} />
                          </Grid>
                          }
                        </Grid>
                      }
                      case 12: {
                        return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                          <Grid item md={6} xs={12}>
                            <RadioForm name={"nReplyID12"} options={objMasterData.lstReply12 || []} isShowRow isNoLabel onChange={(e) => {
                              setnReplyID12(undefinedOrNull(e, "number"))
                            }} />

                          </Grid>
                          <Grid item md={2} xs={12}>
                            {nReplyID12 === 83 && <InputNumberForm name={"nGestational12"} label={"อายุครรภ์"} maxDigits={0} maxInteger={1} required/>}
                          </Grid>
                        </Grid>
                      }
                    }
                  })()}

                </div>
              </div>
            </div>
          </Grid>
        })}
        <Grid item md={12} xs={12}></Grid>
        <Grid item md={6} xs={6}>
          <Grid marginTop={4} container direction="row" alignItems="start" justifyContent="start" sx={{}}>
            <button className="buttonBack" onClick={handleBack}>
              <FiArrowLeft />
              <span>กลับ</span>
            </button>
          </Grid>
        </Grid>
        <Grid item md={6} xs={6}>
          <Grid marginTop={4} container direction="row" alignItems="end" justifyContent="end" sx={{}}>
            <button className="buttonNext" onClick={formStep6.handleSubmit(() => { handleNext(); })}>
              <span>ต่อไป</span>
              <FiArrowRight />
            </button>
          </Grid>
        </Grid>

      </Grid>
    </FormProvider>
  )
};

export default StepForm6;
